import { Cast } from '../hooks/use-cast';

export function assertsCastRequired(cast: Cast): asserts cast is Required<Cast> {
  if (!cast.session) {
    throw new Error('Cast session is not available');
  }

  if (!cast.media) {
    throw new Error('Cast media session is not available');
  }
}

export function assertsCastSession(cast: Cast): asserts cast is Cast & { session: cast.framework.CastSession } {
  if (!cast.session) {
    throw new Error('Cast session is not available.');
  }
}

export function hasCastSession(cast: Cast): cast is Cast & { session: cast.framework.CastSession } {
  if (cast.sessionStatus === 'connected' && cast.session !== undefined) {
    return true;
  }

  return false;
}
